import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FinalCallToAction() {
  return <section data-section-id="245587" id="finalcta" className="relative flex items-center justify-center overflow-hidden bg-background py-[100px] md:py-[120px]">
      {}
      <div className="absolute inset-0 animate-pulse bg-[radial-gradient(circle_at_center,var(--color-ring)_0%,transparent_60%)] opacity-5" style={{
      animationDuration: "8s"
    }} />

      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
        <span className="mb-6 font-default text-sm uppercase tracking-[0.2em] text-ring">
          IFA AI TECH LOGIC AB
        </span>

        <h2 className="mb-6 font-default text-5xl font-bold leading-tight text-foreground md:text-[3.5rem]">
          Redo att ta nästa steg?
        </h2>

        <p className="mb-8 max-w-2xl text-lg font-normal text-foreground/80 md:text-xl">Låt oss bli din långsiktiga partner i din digitala transformation.</p>

        <Button asChild size="lg" className="font-medium inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-4 group relative h-14 rounded-md border-none bg-primary px-8 font-default text-primary-foreground transition-all duration-500 !font-semibold !text-base disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/20">
          <Link to="/kontakt">Boka kostnadsfri konsultation</Link>
        </Button>
      </div>
    </section>;
}